// extracted by mini-css-extract-plugin
export default {"flightDutyLabel":"DutyLabel_flightDutyLabel__BBH42","preAssignedLabel":"DutyLabel_preAssignedLabel__I-sFV","disruptive":"DutyLabel_disruptive__f8mzm"};